export const getToken = () => {
    const rawData = localStorage.getItem("auth")
    if (!rawData) return null
    const parsed = JSON.parse(rawData)
    return parsed?.token ?? null
}